var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useRef } from 'react';
import { Field, useForm } from 'react-final-form';
import { FFInputText } from '../text/text';
import { HiddenInput } from '../hidden/hidden';
import { P, Button } from '@tpr/core';
import elementStyles from '../elements.module.scss';
import styles from './addressLookup.module.scss';
export var EditAddress = React.memo(function (_a) {
    var initialValue = _a.initialValue, value = _a.value, loading = _a.loading, testId = _a.testId, onChangeAddressClick = _a.onChangeAddressClick, addressLine1Label = _a.addressLine1Label, addressLine1RequiredMessage = _a.addressLine1RequiredMessage, addressLine2Label = _a.addressLine2Label, addressLine3Label = _a.addressLine3Label, townLabel = _a.townLabel, countyLabel = _a.countyLabel, postcodeLabel = _a.postcodeLabel, countryLabel = _a.countryLabel, changeAddressButton = _a.changeAddressButton;
    var form = useForm();
    function isDirty() {
        var selectedAddress = form.getFieldState('selectedAddress');
        return selectedAddress && selectedAddress.dirty;
    }
    function renderNonEditableFieldWithUpdates(fieldName, label) {
        return (React.createElement(React.Fragment, null,
            label && (React.createElement(P, { className: styles.nonEditable },
                React.createElement("strong", { id: (testId ? testId + '-' : '') + fieldName, className: elementStyles.labelText + " " + styles.nonEditableLabel }, label),
                ' ',
                React.createElement("span", { "aria-labelledby": (testId ? testId + '-' : '') + fieldName }, value ? value[fieldName] : initialValue[fieldName]))),
            React.createElement(Field, { name: fieldName, type: "hidden", "data-testid": (testId ? testId + '-' : '') + fieldName + '-hidden', initialValue: isDirty() ? value[fieldName] : initialValue[fieldName], updatedValue: value ? value[fieldName] : '', render: function (props) { return React.createElement(HiddenInput, __assign({ type: "hidden" }, props)); } })));
    }
    function renderInitialValueField(fieldName, value) {
        return (React.createElement(Field, { name: 'initialValue.' + fieldName, "data-testid": (testId ? testId + '-' : '') + fieldName + 'InitialValue-hidden', initialValue: value, render: function (props) { return React.createElement(HiddenInput, __assign({ type: "hidden" }, props)); } }));
    }
    var address1ref = useRef(null);
    var address2ref = useRef(null);
    useEffect(function () {
        var blurEvent = new Event('blur', { bubbles: true });
        address1ref.current.dispatchEvent(blurEvent);
        address2ref.current.dispatchEvent(blurEvent);
    }, [value]);
    return (React.createElement(React.Fragment, null,
        React.createElement(FFInputText, { ref: address1ref, name: "addressLine1", label: addressLine1Label, disabled: loading, testId: (testId ? testId + '-' : '') + 'addressLine1', initialValue: isDirty() ? value.addressLine1 : initialValue.addressLine1, updatedValue: value ? value.addressLine1 : '', validate: function (value) {
                return value && value.trim().length > 1
                    ? undefined
                    : addressLine1RequiredMessage;
            }, inputWidth: 6, maxLength: 100 }),
        React.createElement(FFInputText, { ref: address2ref, name: "addressLine2", label: addressLine2Label, disabled: loading, testId: (testId ? testId + '-' : '') + 'addressLine2', initialValue: isDirty() ? value.addressLine2 : initialValue.addressLine2, updatedValue: value ? value.addressLine2 : '', inputWidth: 6, maxLength: 100 }),
        renderNonEditableFieldWithUpdates('addressLine3', addressLine3Label),
        renderNonEditableFieldWithUpdates('postTown', townLabel),
        renderNonEditableFieldWithUpdates('county', countyLabel),
        renderNonEditableFieldWithUpdates('postcode', postcodeLabel),
        renderNonEditableFieldWithUpdates('nationId'),
        renderNonEditableFieldWithUpdates('country', countryLabel),
        renderNonEditableFieldWithUpdates('countryId'),
        renderNonEditableFieldWithUpdates('uprn'),
        initialValue &&
            renderInitialValueField('addressLine1', initialValue.addressLine1),
        initialValue &&
            renderInitialValueField('addressLine2', initialValue.addressLine2),
        initialValue &&
            renderInitialValueField('addressLine3', initialValue.addressLine3),
        initialValue &&
            renderInitialValueField('postTown', initialValue.postTown),
        initialValue && renderInitialValueField('county', initialValue.county),
        initialValue &&
            renderInitialValueField('postcode', initialValue.postcode),
        initialValue &&
            renderInitialValueField('nationId', initialValue.nationId && initialValue.nationId.toString()),
        initialValue &&
            renderInitialValueField('country', initialValue.country),
        initialValue &&
            renderInitialValueField('countryId', initialValue.countryId && initialValue.countryId.toString()),
        initialValue &&
            renderInitialValueField('uprn', initialValue.uprn && initialValue.uprn.toString()),
        React.createElement(Button, { onClick: onChangeAddressClick, testId: (testId ? testId + '-' : '') + 'change-address', appearance: "secondary", size: "small", className: styles.button }, changeAddressButton)));
});
//# sourceMappingURL=editAddress.js.map